"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var PropsTable =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(PropsTable, _PureComponent);

  function PropsTable() {
    (0, _classCallCheck2["default"])(this, PropsTable);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PropsTable).apply(this, arguments));
  }

  (0, _createClass2["default"])(PropsTable, [{
    key: "render",
    value: function render() {
      var propInfos = this.props.propInfos;
      return _react["default"].createElement("div", {
        className: "styled-table"
      }, _react["default"].createElement("h3", null, "Props"), _react["default"].createElement("div", null, _react["default"].createElement("table", {
        className: "table table-bordered"
      }, _react["default"].createElement("thead", null, _react["default"].createElement("tr", null, _react["default"].createElement("th", null, "Name"), _react["default"].createElement("th", null, "Type"), _react["default"].createElement("th", null, "Default"), _react["default"].createElement("th", null, "Description"))), _react["default"].createElement("tbody", null, propInfos.map(function (el) {
        return _react["default"].createElement(el.type, (0, _extends2["default"])({
          key: el.props.name
        }, el.props));
      })))));
    }
  }]);
  return PropsTable;
}(_react.PureComponent);

exports["default"] = PropsTable;
PropsTable.propTypes = {
  propInfos: _propTypes["default"].arrayOf(_propTypes["default"].node)
};